import axios from 'axios';
import { SKILLS_ASSESSMENT_REPORTS_API } from 'config/constants';

const { get } = axios;

export type SkillsAssessmentScoreItem = {
  id: string;
  maximum: number;
  name: string;
  points: number;
  score: number;
  providers?: {
    action: string;
    href: string;
    id: string;
    label: string;
    name: string;
    summary: string;
  }[];
};

export type SkillsAssessment = {
  id: string;
  metadata: {
    assessment: {
      id: string;
      name: string;
      partnerFinishOfferId: string;
      partnerStartOfferId: string;
      rhFinishOfferId: string;
      rhStartOfferId: string;
    };
    deputy: { fullname: string };
    user: { email: string; fullname: string };
  };
  score: SkillsAssessmentScoreItem[];
  statistics: { duration: number };
  suggestions: {
    action: string;
    href: string;
    id?: string;
    label: string;
    name: string;
    summary: string;
  }[];
  timestamp: string;
};

export const isSkillsAssessmentClientError = (error: unknown): boolean => {
  const status = (error as { response?: { status?: number } })?.response
    ?.status;

  return typeof status === 'number' && status >= 400 && status < 500;
};

export const getUserAssessments = async (
  username: string,
): Promise<SkillsAssessment[]> => {
  const response = await get(
    SKILLS_ASSESSMENT_REPORTS_API.replace('<username>', username),
  );
  return response.data?.skill_reports ?? [];
};
